import React from "react";
import "./BasicSettings.css";

export default function BasicSettings() {
  return (
    <div className="basic-settings-page">
      {/* Page Header */}
      <div className="page-header">
        <h2>App Basic Settings</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / App Settings / <span>App Basic Settings</span>
        </div>
      </div>

      {/* Section: Update App Basic Settings */}
      <div className="card">
        <h3>Update App Basic Settings</h3>
        <div className="form-grid">
          <div>
            <label>Site Name</label>
            <input type="text" placeholder="Ample Markets" />
          </div>
          <div>
            <label>Site Timezone</label>
            <select>
              <option>Asia/Dubai</option>
              <option>Asia/Kolkata</option>
              <option>UTC</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable KYC</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Site URL</label>
            <input type="text" placeholder="http://amplemarkets.com" />
          </div>
          <div>
            <label>Dashboard URL</label>
            <input type="text" placeholder="http://my.amplemarkets.com" />
          </div>
          <div>
            <label>Tawk.to Property ID</label>
            <input type="text" />
          </div>
          <div>
            <label>Tawk.to Widget ID</label>
            <input type="text" />
          </div>
          <div>
            <label>Questionnaire for Client</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
        </div>
        <button className="btn-submit">Update</button>
      </div>

      {/* Section: Registration Form Fields */}
      <div className="card">
        <h3>Update Registration Form Fields</h3>
        <div className="form-grid">
          <div>
            <label>Enable/Disable Password</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable Middle Name</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable State</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable City</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable Date of Birth</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Age Limit</label>
            <input type="text" placeholder="18 (Ex: 5 under age limit is 5 years)" />
          </div>
          <div>
            <label>Client Verification</label>
            <select>
              <option>Disable</option>
              <option>Enable</option>
            </select>
          </div>
          <div>
            <label>Auth Pages</label>
            <select>
              <option>Simple</option>
              <option>Advanced</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable Password Verification</label>
            <select>
              <option>Disable Password Verification</option>
              <option>Enable Password Verification</option>
            </select>
          </div>
          <div>
            <label>Enable/Disable Company Registration</label>
            <select>
              <option>Disable Company Registration</option>
              <option>Enable Company Registration</option>
            </select>
          </div>
        </div>
        <button className="btn-submit">Update</button>
      </div>

      {/* Section: Links */}
      <div className="card">
        <h3>Update Links</h3>
        <div className="form-grid">
          <div>
            <label>Anti-Money Laundering Policy</label>
            <input type="text" />
          </div>
          <div>
            <label>Client Agreement</label>
            <input type="text" />
          </div>
          <div>
            <label>Deposit Withdrawal Policy</label>
            <input type="text" />
          </div>
          <div>
            <label>Privacy Policy</label>
            <input type="text" />
          </div>
          <div>
            <label>Refund Policy</label>
            <input type="text" />
          </div>
          <div>
            <label>Risk Warning Notice</label>
            <input type="text" />
          </div>
          <div className="full-width">
            <label>Terms and Conditions</label>
            <input type="text" />
          </div>
        </div>
        <button className="btn-submit">Update</button>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}

